/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateServiceAreaDto
 */
export interface CreateServiceAreaDto {
    /**
     * Country code (ISO 3166-1 alpha-3)
     * @type {string}
     * @memberof CreateServiceAreaDto
     */
    countryCode: string;
    /**
     * Admin area 1 code (province/state)
     * @type {string}
     * @memberof CreateServiceAreaDto
     */
    adminArea1Code?: string;
    /**
     * Admin area 2 code (city/district)
     * @type {string}
     * @memberof CreateServiceAreaDto
     */
    adminArea2Code?: string;
}

/**
 * Check if a given object implements the CreateServiceAreaDto interface.
 */
export function instanceOfCreateServiceAreaDto(value: object): value is CreateServiceAreaDto {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function CreateServiceAreaDtoFromJSON(json: any): CreateServiceAreaDto {
    return CreateServiceAreaDtoFromJSONTyped(json, false);
}

export function CreateServiceAreaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateServiceAreaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'adminArea1Code': json['adminArea1Code'] == null ? undefined : json['adminArea1Code'],
        'adminArea2Code': json['adminArea2Code'] == null ? undefined : json['adminArea2Code'],
    };
}

export function CreateServiceAreaDtoToJSON(value?: CreateServiceAreaDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countryCode': value['countryCode'],
        'adminArea1Code': value['adminArea1Code'],
        'adminArea2Code': value['adminArea2Code'],
    };
}

